// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"134":"acf1649c","279":"2580b1df","387":"5980faf0","476":"6ec09535","768":"6326d09a"}[chunkId] + ".chunk.css";
};